/* global OFS_I18N */
module.exports = OFS_I18N || {};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/i18n.js
 **/